import React from "react";
import PropTypes from "prop-types";
import "./brand-colored-card.m.css";

const BrandColoredCard = ({ collection, firstStory }) => {
  const collectionName = collection?.name || "";
  const collectionSummary = collection?.summary || "";

  // Extract cover image from collection metadata
  const coverImageData = collection?.metadata?.["cover-image"];
  const imageUrl =
    coverImageData?.url ||
    coverImageData?.["cover-image-url"] ||
    coverImageData?.["cover-image-s3-key"];
  const imageAlt = collectionName || "Brand Icon";

  const renderIcon = () => {
    if (imageUrl) {
      return (
        <div styleName="icon-placeholder">
          <img
            src={imageUrl}
            alt={imageAlt}
            style={{ width: "48px", height: "48px" }}
          />
        </div>
      );
    }
    return null;
  };

  return (
    <div styleName="brand-card-wrapper">
      <div styleName="brand-colored-card">
        {renderIcon()}
        {collectionName && <h2 styleName="card-title">{collectionName}</h2>}
      </div>
      {collectionSummary && (
        <div styleName="card-description">
          <p>{collectionSummary}</p>
        </div>
      )}
    </div>
  );
};

BrandColoredCard.propTypes = {
  collection: PropTypes.shape({
    name: PropTypes.string,
    summary: PropTypes.string,
    metadata: PropTypes.object,
  }).isRequired,
  firstStory: PropTypes.object,
};

export { BrandColoredCard };
